import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_235: DocMigration = {
  maxSchemaVersion: "0.0.235",
  description: "Rename props for prop placement upgrade",
  apply(json: any) {
    for (const propId in json.props) {
      const prop = json.props[propId];
      // reassign centerX to horizontalAlignment
      if (prop.centerX === true) {
        prop.horizontalAlignment = "CENTER";
      }
      delete prop.centerX;

      // reassign centerY to lateralAlignment
      if (prop.centerY === true) {
        prop.lateralAlignment = "CENTERLINE";
      }
      delete prop.centerY;

      // reassign offset to lateralOffset
      if (prop.offset) {
        prop.lateralOffset = prop.offset;
        delete prop.offset;
      }

      // reassign offsetZ to verticalOffset
      if (prop.offsetZ) {
        prop.verticalOffset = prop.offsetZ;
        delete prop.offsetZ;
      }

      // reassign anchor to verticalDatum
      if (prop.anchor) {
        prop.verticalDatum = prop.anchor;
        delete prop.anchor;
      }
    }

    // fix negative param values for openings for new start/end placement style
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      if (opening && (opening.type === "DOOR_V2" || opening.type === "WINDOW_V2")) {
        if (opening.param < -1e-6) {
          opening.param *= -1;
          opening.paramFromEnd = true;
        }
      }
    }
    for (const columnId in json.columns) {
      const column = json.columns[columnId];
      for (const placementId in column.placements) {
        const placement = column.placements[placementId];
        switch (placement.lateralDatum) {
          case "OUTSIDE_FACE_OF_WALL_STRUCTURE":
            placement.lateralDatum = "OUTSIDE_FACE_OF_FRAMING";
            break;
          case "OUTSIDE_FACE_OF_WALL_SUBSTRATE":
            placement.lateralDatum = "OUTSIDE_FACE_OF_SUBSTRATE";
            break;
          case "OUTSIDE_FACE_OF_WALL_FINISH":
            placement.lateralDatum = "OUTSIDE_FACE_OF_FINISH";
            break;
          case "INSIDE_FACE_OF_WALL_STRUCTURE":
            placement.lateralDatum = "INSIDE_FACE_OF_FRAMING";
            break;
          case "INSIDE_FACE_OF_WALL_SUBSTRATE":
            placement.lateralDatum = "INSIDE_FACE_OF_SUBSTRATE";
            break;
          case "INSIDE_FACE_OF_WALL_FINISH":
            placement.lateralDatum = "INSIDE_FACE_OF_FINISH";
            break;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_235;
